import React, { useState, useMemo } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import MatchList from "../MatchList/MatchList";
import AddMatchBar from "./AddMatchBar";
import IsOfficialSwitch from "./IsOfficialSwitch";
import { useSelector } from "react-redux";
import "../styles/MatchDaysList.css";
import DateComponent from "./DateComponent";
import { getMatches } from "../helpers/getMatches";
import { useTranslation } from "react-i18next";
import TeamSelect from "../MatchList/formComponents/TeamSelect";

export default function MatchDayBlock({ matchDay }) {
    const matchesState = useSelector((state) => state.matchesReducer.data);
    const [isOfficial, setIsOfficial] = useState(matchDay?.isOfficial);
    const { t } = useTranslation();

    const matches = useMemo(
        () => getMatches(matchDay, matchesState),
        [matchDay, matchesState]
    );

    return (
        <Accordion defaultExpanded elevation={5}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <Typography>{`${t("gamedays.matchday_block.title")} ${
                    matchDay.dayID
                }`}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <div className="matchdays-block-header">
                    <DateComponent
                        matches={matches ?? []}
                        matchDay={matchDay}
                    />
                    <div>
                        <IsOfficialSwitch
                            matchDay={matchDay}
                            isOfficial={isOfficial}
                            setIsOfficial={setIsOfficial}
                        />
                        <TeamSelect matchDay={matchDay} />
                    </div>
                </div>
                <MatchList
                    matches={matches}
                    withForm={true}
                    matchDayId={matchDay?.matchDayKey}
                    disabled={isOfficial}
                    matchDay={matchDay}
                />
                <AddMatchBar matchDay={matchDay} disabled={isOfficial} />
            </AccordionDetails>
        </Accordion>
    );
}
